import { ItemTypeEntity } from '@entities/ItemType/Types';
import { useNavigate, useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { HasItems } from '@modules/Steps/Shared/Helpers/HasItems';
import css from './ItemTypeInfoMobile.module.css';
import BasicButton from '@shared/Ui/Buttons/BasicButton/BasicButton';
import { ItemInfoMobile } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/ItemTypesListMobile/ItemTypeInfoMobile/ItemInfoMobile/ItemInfoMobile';
import ExclamationIcon from '@shared/Icons/ExclamationIcon';
import { ROUTES } from '@configs/AppRoutes';
import PlusIcon from '@shared/Icons/PlusIcon';
import DropdownButton from '@shared/Ui/Buttons/DropdownButton/DropdownButton';
import { useFragmentsStore } from '../../../../../../../../Stores/FragmentsStore';
import { StepsViewModeEnum } from '@shared/Enums/StepsViewModeEnum';
import { FormatNumber } from '@shared/Helpers/FormatValue/FormatNumber/FormatNumber';

interface ItemTypeInfoMobileProps {
    itemType: ItemTypeEntity;
}

export const ItemTypeInfoMobile: React.FC<ItemTypeInfoMobileProps> = ({
    itemType,
}) => {
    const { itemTypesWithItems } = useFragmentsStore();
    const navigate = useNavigate();
    const { projectId, viewMode } = useParams();

    const { title, qty, unit, id, fairMarketPrice } = itemType;

    const [expanded, setExpanded] = useState(false);
    const handleToggleExpanded = () => {
        setExpanded(prev => !prev);
    };

    const handleOpenModal = () => {
        if (viewMode === StepsViewModeEnum.PRESENTATION) {
            navigate(
                ROUTES.STEP2_SELECT_ITEMS.getPath(
                    StepsViewModeEnum.PRESENTATION,
                    null,
                    `${id}`
                )
            );
        } else {
            navigate(
                ROUTES.STEP2_SELECT_ITEMS.getPath(
                    StepsViewModeEnum.PROJECT,
                    projectId!,
                    `${id}`
                )
            );
        }
    };

    const isItemTypeWithItems = HasItems(itemType.id, itemTypesWithItems);

    const renderTableRow = () => {
        if (itemType.items?.length) {
            return itemType.items.map(item => (
                <ItemInfoMobile
                    item={item}
                    openModal={handleOpenModal}
                    key={item.uuid}
                    isLabour={itemType.labor}
                />
            ));
        }

        if (fairMarketPrice && !isItemTypeWithItems) {
            const totalPrice = parseFloat(fairMarketPrice) * qty;

            return (
                <div className={css.itemContainer}>
                    <div className={css.emptyItemTypeMobile}>
                        Fair market price
                    </div>
                    <div className={css.itemInfoTypeMobile}>
                        <span>Calculated QTY</span>
                        <span className={css.itemInfoValueMobile}>{qty}</span>
                    </div>
                    <div className={css.itemInfoTypeMobile}>
                        <span>Unit price</span>
                        <span className={css.itemInfoValueMobile}>
                            R {fairMarketPrice}
                        </span>
                    </div>
                    <div className={css.itemInfoTypeMobile}>
                        <span>Total</span>
                        <span className={css.itemInfoValueMobile}>
                            R {FormatNumber(totalPrice, '.', 2)}
                        </span>
                    </div>
                </div>
            );
        }

        if (isItemTypeWithItems) {
            return (
                <div className={css.itemContainer}>
                    <BasicButton
                        className={css.selectProductBtn}
                        disabled={itemType.labor}
                        onClick={handleOpenModal}
                    >
                        <PlusIcon
                            width={25}
                            height={25}
                            stroke={itemType.labor ? '#9D9D9D' : '#0053A0'}
                        />
                        Select product
                    </BasicButton>

                    <div className={css.itemInfoTypeMobile}>
                        <span>Calculated QTY</span>
                        <span className={css.itemInfoValueMobile}>0</span>
                    </div>
                    <div className={css.itemInfoTypeMobile}>
                        <span>Unit price</span>
                        <span className={css.itemInfoValueMobile}>R 0.00</span>
                    </div>
                    <div className={css.itemInfoTypeMobile}>
                        <span>Total</span>
                        <span className={css.itemInfoValueMobile}>R 0.00</span>
                    </div>
                </div>
            );
        }

        return (
            <div className={css.itemContainer}>
                <div className={css.emptyItemTypeMobile}>
                    <div className={css.emptyItemTypeIcon}>
                        <ExclamationIcon />
                    </div>
                    <div>There is no option to select a product!</div>
                </div>
                <div className={css.itemInfoTypeMobile}>
                    <span>Calculated QTY</span>
                    <span className={css.itemInfoValueMobile}>0</span>
                </div>
                <div className={css.itemInfoTypeMobile}>
                    <span>Unit price</span>
                    <span className={css.itemInfoValueMobile}>R 0.00</span>
                </div>
                <div className={css.itemInfoTypeMobile}>
                    <span>Total</span>
                    <span className={css.itemInfoValueMobile}>R 0.00</span>
                </div>
            </div>
        );
    };

    return (
        <div className={css.itemTypeInfoContainerMobile}>
            <div className={css.itemTypeInfoMobile}>
                <div className={css.itemTypeNameMobile}>
                    <div>{title}</div>
                    <div className={css.itemTypeQtyMobile}>
                        {qty} ({unit})
                    </div>
                </div>
                <DropdownButton
                    onClick={handleToggleExpanded}
                    isOpen={expanded}
                />
            </div>
            <div
                className={`${css.itemsListMobile} ${expanded ? css.showItemsListMobile : ''}`}
            >
                {renderTableRow()}
            </div>
        </div>
    );
};
